<div class="user-manager-class" id="process-order">

  
    <div class="content-top-box">
      <ul class="breadcrumb">
  
        <li class="breadcrumb-item">
  
          <a class="breadcrumb-link" routerLink="/Access">Access</a>
        </li>
      </ul>
      <div class="top-box-content">
        <h1 class="main-title">Manage Security Policy</h1>
      </div>
    </div>
  
    <form [formGroup]="userForm">
      <!-- (ngSubmit)="unitDetailFormFormSubmit()" -->
      <div class="wrapper-box wrapper-box-shadow table-wrapper">
        <div class="content-top-box-content">
          <!-- <h1 class="content-title">Manage Security Policy</h1> -->
        </div>
        <div class="content-top-row content-top-row-order-processing">
          <!-- <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"> -->
          <mat-form-field style="margin-top: 0px" appearence="fill"
            class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <!-- <label>Group</label> -->
            <mat-select placeholder="Group" (selectionChange)="onGroupChange($event)" panelClass="testClass"
              formControlName="group" [(ngModel)]="GroupId">
              <mat-option *ngFor="let group of groupList" [value]="group.TypeId">{{group.TypeName}}</mat-option>
            </mat-select>
  
          </mat-form-field>
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
  
            <input matInput placeholder="Search Record" (keyup)="applyFilter($event)" autocomplete="off">
          </mat-form-field>
  
  
          <button class="add-btn" (click)="openModal()">
            <img src="assets/images/add.png" alt="" width="20px" height="20px">
          </button>
  
        </div>
        <table mat-table [dataSource]="policyData" class="basic-table plant-model-table" matSort>
          <!-- PO Column -->
          <ng-container matColumnDef="policyId">
            <th mat-header-cell mat-sort-header-pointer-middle *matHeaderCellDef mat-sort-header class="header-min-width">
              <p class="header-text">Policy Id</p>
            </th>
            <td mat-cell *matCellDef="let element">{{ element.id }}</td>
          </ng-container>
  
          <!-- Item Code Column -->
          <ng-container matColumnDef="minimumLength">
            <th mat-header-cell mat-sort-header-pointer-middle *matHeaderCellDef mat-sort-header class="header-min-width">
              <p class="header-text">Minimum Length</p>
            </th>
            <td mat-cell *matCellDef="let element">{{ element.minimumLength }}</td>
          </ng-container>
  
          <!-- PO Target Column -->
          <ng-container matColumnDef="isAlphanumeric">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">Alphanumeric</p>
            </th>
            <td mat-cell *matCellDef="let element">{{ element.isAlphanumeric }}</td>
          </ng-container>
  
          <!-- Planned Start Column -->
          <ng-container matColumnDef="isSymbols">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">Is Special Char Must</p>
            </th>
            <td mat-cell *matCellDef="let element">{{ element.isSymbols }}</td>
          </ng-container>
  
          <!-- Planned End Column -->
          <ng-container matColumnDef="expiryPeriod">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="grp-order">
              <p class="header-text">Password Expiry Period (Days)</p>
            </th>
            <td mat-cell *matCellDef="let element">{{ element.expiryPeriodDayWise }}</td>
          </ng-container>
  
          <!-- active Column -->
          <ng-container matColumnDef="logOffTimeOut">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-min-width">
              <p class="header-text">Log Off TimeOut (Hours)</p>
            </th>
            <div>
                <td mat-cell *matCellDef="let element">{{ element.logOffTimeOutHourly }}</td>
            </div>
          </ng-container>
  
          <ng-container matColumnDef="failedAttempt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-min-width">
              <p class="header-text">Failed Attempt</p>
            </th>
            <div>
                <td mat-cell *matCellDef="let element">{{ element.failedAttempt }}</td>
            </div>
          </ng-container>

          <ng-container matColumnDef="noOfPreviousPass">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-min-width">
              <p class="header-text">No Of Previous Password</p>
            </th>
            <div>
                <td mat-cell *matCellDef="let element">{{ element.noOfPreviousPassword }}</td>
            </div>
          </ng-container>
  
          <!-- userManagerActions Column -->
          <ng-container matColumnDef="policyActions">
            <th mat-header-cell *matHeaderCellDef>
              <p class="header-text">Actions</p>
            </th>
            <td mat-cell *matCellDef="let element" class="row-action-btns-column">
              <div class="row-action-btns">
                <button mat-icon-button class="edit-btn" aria-label="Edit Row" (click)="openEditPolicyItemModel(element)">
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M0.75 9.06298V11.2505H2.9375L9.38917 4.79881L7.20167 2.61131L0.75 9.06298ZM11.0808 3.10715C11.3083 2.87965 11.3083 2.51215 11.0808 2.28465L9.71583 0.919648C9.48833 0.692148 9.12083 0.692148 8.89333 0.919648L7.82583 1.98715L10.0133 4.17465L11.0808 3.10715Z"
                      fill="white" />
                  </svg>
                </button>
                <button mat-icon-button class="tree-view-btn" aria-label="View Row Tree"
                  (click)="deletePolicy(element)">
                  <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M0 10C0 4.47715 4.47715 0 10 0H24C29.5228 0 34 4.47715 34 10V24C34 29.5228 29.5228 34 24 34H10C4.47715 34 0 29.5228 0 24V10Z"
                      fill="#F85439" />
                    <circle cx="17" cy="17" r="14" fill="#F85439" />
                    <path
                      d="M20.9157 12.2611H18.874L18.2907 11.6777H15.374L14.7907 12.2611H12.749V13.4277H20.9157V12.2611ZM13.3324 21.0111C13.3324 21.3205 13.4553 21.6172 13.6741 21.836C13.8929 22.0548 14.1896 22.1777 14.499 22.1777H19.1657C19.4751 22.1777 19.7719 22.0548 19.9906 21.836C20.2094 21.6172 20.3324 21.3205 20.3324 21.0111V14.0111H13.3324V21.0111Z"
                      fill="white" />
                  </svg>
                </button>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="policyColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: policyColumns"></tr>
        </table>
        <mat-paginator class="basic-paginataor" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
      </div>
    </form>
    <!--new code-->
    <div class="sidepanel-model-wrapper edit-plant-row-model" [ngClass]="{'active': displayUserModal}">
      <div class="sidepanel-close" (click)="closeaddNewPlantItemModel()"></div>
      <div class="model-content">
        <div class="model-top">
          <h2 class="model-title">{{formMode ? 'Add' : 'Update'}} Manage Security Policy</h2>
          <button mat-icon-button class="model-close-btn" aria-label="Close model" (click)="closeaddNewPlantItemModel()">
            <svg width="14" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.46 7L14 12.54V14H12.54L7 8.46L1.46 14H0V12.54L5.54 7L0 1.46V0H1.46L7 5.54L12.54 0H14V1.46L8.46 7Z"
                fill="black" />
            </svg>
          </button>
        </div>
        <div class="model-body">
          <form [formGroup]="policyForm"
            (ngSubmit)="formMode ? addNewPolicyFormSubmit() : editPolicyFormSubmit()">
            <div class="form-group">
              <mat-form-field [ngClass]="{
                  'is-invalid':
                  policyForm.get('minimumLength')?.errors &&
                  policyForm.get('minimumLength')?.touched
                }" appearance="fill" class="field-fill">
                <mat-label>Minimum Length</mat-label>
                <input type="number" matInput placeholder="Password Minimum Length" formControlName="minimumLength" ng-pattern="/[1-9]/">
              </mat-form-field>
              <p class="invalid-feedback" *ngIf="
              policyForm.get('minimumLength')?.touched &&
              policyForm.get('minimumLength')?.hasError('required')">
                * Minimum Length is required!
              </p>
              <p class="invalid-feedback" *ngIf="
              policyForm.get('minimumLength')?.touched &&
              policyForm.get('minimumLength')?.hasError('min')">
                * invalid!
              </p>
            </div>
            <div class="form-group">
                <mat-checkbox color="accent" formControlName="isAlphanumeric"> IsAlphanumeric </mat-checkbox>
            </div>
            <div class="form-group">
              <mat-checkbox color="accent" formControlName="isSymbol"> Is Special Char Must </mat-checkbox>
            </div>
            <div class="form-group">
              <mat-checkbox color="accent" (change)="CheckStatus()" formControlName="isCheckPreviousPass"> IsCheckPreviousPassword </mat-checkbox>
            </div>
            <div class="form-group" *ngIf="isCheckPrevious">
              <mat-form-field appearance="fill" class="field-fill">
                <mat-label>No Of Previous Password</mat-label>
                <input type="number" matInput formControlName="noOfPreviousPass" ng-pattern="/[1-9]/">
              </mat-form-field>
              <p class="invalid-feedback" *ngIf="
              policyForm.get('noOfPreviousPass')?.touched &&
              policyForm.get('noOfPreviousPass')?.hasError('required')">
                * noOfPreviousPass is required!
              </p>
              <p class="invalid-feedback" *ngIf="
              policyForm.get('noOfPreviousPass')?.touched &&
              policyForm.get('noOfPreviousPass')?.hasError('min')">
                * invalid!
              </p>
            </div>
            <div class="form-group">
              <mat-form-field [ngClass]="{
                'is-invalid':
                policyForm.get('expiryPeriod')?.errors &&
                policyForm.get('expiryPeriod')?.touched
              }" appearance="fill" class="field-fill">
                <mat-label>Password Expiry Period (Days)</mat-label>
                <input type="number" matInput formControlName="expiryPeriod" ng-pattern="/[1-9]/">
              </mat-form-field>
              <p class="invalid-feedback" *ngIf="
              policyForm.get('expiryPeriod')?.touched &&
              policyForm.get('expiryPeriod')?.hasError('required')">
                * expiryPeriod is required!
              </p>
              <p class="invalid-feedback" *ngIf="
              policyForm.get('expiryPeriod')?.touched &&
              policyForm.get('expiryPeriod')?.hasError('min')">
                * invalid!
              </p>
            </div>
            <div class="form-group">
              <mat-form-field appearance="fill" class="field-fill">
                <mat-label>Log Off TimeOut (Hours)</mat-label>
                <input type="number" matInput type="number" formControlName="logOffTimeOut" ng-pattern="/[1-9]/">
              </mat-form-field>
              <p class="invalid-feedback" *ngIf="
              policyForm.get('logOffTimeOut')?.touched &&
              policyForm.get('logOffTimeOut')?.hasError('required')">
                * expiryPeriod is required!
              </p>
              <p class="invalid-feedback" *ngIf="
              policyForm.get('logOffTimeOut')?.touched &&
              policyForm.get('logOffTimeOut')?.hasError('min')">
                * invalid!
              </p>
            </div>
            <div class="form-group">
              <mat-form-field appearance="fill" class="field-fill">
                <mat-label>Failed Attempt</mat-label>
                <input type="number" matInput formControlName="failedAttempt" ng-pattern="/[1-9]/">
              </mat-form-field>
              <p class="invalid-feedback" *ngIf="
              policyForm.get('failedAttempt')?.touched &&
              policyForm.get('failedAttempt')?.hasError('required')">
                * expiryPeriod is required!
              </p>
              <p class="invalid-feedback" *ngIf="
              policyForm.get('failedAttempt')?.touched &&
              policyForm.get('failedAttempt')?.hasError('min')">
                * invalid!
              </p>
            </div>
            <div class="model-form-actions">
              <button type="button" mat-flat-button class="btn-cancel" (click)="closeaddNewPlantItemModel()"> Cancel
              </button>
              <button mat-flat-button color="accent" [disabled]="!policyForm.valid" class="btn-accent" type="submit">
                {{formMode ? 'Add' : 'Update'}} </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  
  </div>
